import { createStore } from "owa-satcheljs";
interface SelectedCalendarsStore {
    selectedCalendars: Map<string, string[]>;
}
const selectedCalendarsStoreData: SelectedCalendarsStore = {
    selectedCalendars: new Map<string, string[]>(),
};

export const getSelectedCalendarsStore: () => SelectedCalendarsStore = createStore<SelectedCalendarsStore>("selectedCalendarsStore", selectedCalendarsStoreData);
